import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment'
import router from './router'
import i18n from './i18n'
import io from 'socket.io-client';
const app = require('./main');


// modules
import estimate from './modules/estimate'
import quotation from './modules/quotation'
import salesOrder from './modules/salesOrder'
import invoice from './modules/invoice'
import notifications from './modules/notifications'

// To Do
import toDo from './modules/toDo.js'
// About
import about from './modules/about.js'

// const socket = io(location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: ''), {
//   autoConnect: false,
//   transports: ['websocket'],
//   path: '/api/notifications/socket.io',
//   query: {
//     token: sessionStorage.getItem('token'),
//   },
// })

console.log('app', app);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    toDoP: null,
    toDoE: null,
    toDoBU: null,
    user: [],
    myCompanys: [],
    // MENU STATISTICS
    menuStatistics: {},
    activeSubscription: true,
    subscription: {},
    // INFO TABS
    projectTeamGridData: [],
    taskTeamGridData: [],
    projectClientsGridData: [],
    taskClientsGridData: [],
    projectVendorsData: [],
    taskVendorsGridData: [],
    // PROGRESS INFO
    progressData: [],
    // USERS: ROW DATA
    rowDataUsers: [],
    // VENDORS, CLIENTS: ROW DATA
    rowDataVendors: [],
    rowDataClients: [],
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA
    rowDataVendorsPerson: [],
    rowDataClientsPerson: [],
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA ->
    rowDataVendorsPersonClear: [],
    rowDataClientsPersonClear: [],
    // PROGRESS INFO BUSINESS UNIT
    depProgressData: [],
    // PROGRESS INFO BUSINESS UNIT
    engagementProgressData: [],
    //PROJECT FILES
    projecFiles: [],
    vendorsFiles: [],
    vendorsPersonsFiles: [],
    clientsFiles: [],
    clientsPersonsFiles: [],
    //TASK FILES
    taskFiles: [],
    //PROJECT COMMENTS
    projectComments: [],
    //BUSSINESS UNIT COMMENTS
    businessUnitComments: [],
    //engagement COMMENTS
    engagementComments: [],
    //BUSSINESS UNIT TASK COMMENTS
    businessUnitTaskComments:[],
    //engagement TASK COMMENTS
    engagementTaskComments:[],
    //PROJECT TASK COMMENTS
    projectTaskComments: [],
    //PROJECT MEETINGS
    projectMeetings: [],
    // MEETINGS
    meetings: [],
    //BUSSINESS UNIT MEETINGS
    businessUnitMeetings: [],
    //BUSSINESS UNIT MEETINGS
    engagementMeetings: [],
    //PROJECT TASK MEETINGS
    projectTaskMeetings: [],
    //BUSSINESS UNIT TASK MEETINGS
    businessUnitTaskMeetings: [],
    //CASE TASK MEETINGS
    engagementTaskMeetings: [],
    //BUSSINESS UNIT FILES
    businessUnitFiles: [],
    //СASE FILES
    engagementFiles: [],
    //BUSSINESS UNIT TASK FILES
    depTaskFiles:[],
    casTaskFiles:[],
    //SEND LOG
    sendLog: '',
    // TEMPLATES PROJECT, TEMPLATES BUSINESS UNIT
    templatesProject: null,
    templatesBusinessUnit: null,
    templatesEngagement: null,
    // MESSAGES
    messagesDirectories: null,
    messagesList: null,
    // NEWS MENU
    newsMenu: null,
    // PROJECT HISTORY
    projectHistory: [],
    // PROJECT TASK HISTORY
    projectTaskHistory:[],
    // BUSINESS UNIT HISTORY
    businessUnitHistory:[],
    // BUSINESS UNIT HISTORY
    engagementHistory:[],
    // BUSINESS UNIT TASK HISTORY
    businessUnitTaskHistory:[],
    // CASE TASK HISTORY
    engagementTaskHistory:[],
    // USER HISTORY
    userHistory: [],
    // CALENDAR LIST
    calendarList: null,

    // TIMER LIST
    timerList: [],
    timerListDep: [],
    timerListCas: [],

    // HRIS
    hrisList: null,

    // Rate
    costType: null,
    rateReport: null,

    // Invoices
    invoicesList: null,
    // Invoice Item
    invoiceItem: null,
    // BusinessUnit Projects list
    businessUnitProjectsList: [],
    // BusinessUnit Engagement list
    businessUnitEngagementsList: [],
    // permissions
    projectUsersPermissions: [],
    engagementUsersPermissions: [],
    businessUnitUsersPermissions: [],
    // Directories create invoices
    directoriesCreateInvoices: null,
    // Company Layout
    companyLayout: null,
    // documents
    documents: {
      sop: null
    },
    documentsBU: {
      sop: null
    },
    documentsE: {
      sop: null
    },
    sidebar: {
      opened: false
    },
    activeCompanyName: '',
    // material
    projectMaterialDirectories: null,
    projectMaterialItem: null,
    // material project
    projectMaterialDirectoriesProj: null,
    projectMaterialItemProj: null,
    // quotation
    quotationList: null,
    // purchases
    purchaseList: [],
    purchaseOrderList: [],
    isInventoryManager: false,
    notificationDuration: 0,
    viewerSettings: {
      "movable": true
    }
  },
  mutations: {
    // quotation
    getQuotationList(state, payload) {
      state.quotationList = payload
    },
    // material
    getProjectMaterialDirectories(state, payload) {
      state.projectMaterialDirectories = payload
    },
    getProjectMaterialItem(state, payload) {
      state.projectMaterialItem = payload
    },
    // material project
    getProjectMaterialDirectoriesProj(state, payload) {
      state.projectMaterialDirectoriesProj = payload
    },
    getProjectMaterialItemProj(state, payload) {
      state.projectMaterialItemProj = payload
    },
    // documents
    getDocuments(state, payload) {
      state.documents = payload
    },
    getDocumentsBU(state, payload) {
      state.documentsBU = payload
    },
    getDocumentsE(state, payload) {
      state.documentsE = payload
    },
    // Invoices
    getInvoicesList(state, payload) {
      state.invoicesList = payload
    },
    // Invoice Item
    getInvoiceItem(state, payload) {
      state.invoiceItem = payload
    },
    // Business Unit Project List
    getBusinessUnitProjectsList(state, payload) {
      state.businessUnitProjectsList = payload
    },
    getBusinessUnitEngagementList(state, payload) {
      state.businessUnitEngagementsList = payload
    },
    getProjectPermissionsList(state, payload) {
      state.projectUsersPermissions = payload
    },
    getEngagementPermissionsList(state, payload) {
      state.engagementUsersPermissions = payload
    },
    getBusinessUnitPermissionsList(state, payload) {
      state.businessUnitUsersPermissions = payload
    },
    // Company Layout
    getCompanyLayout(state, payload) {
      state.companyLayout = payload
    },
    // Directories create invoices
    getDirectoriesCreateInvoices(state, payload) {
      state.directoriesCreateInvoices = payload
    },
    // Rate
    getCostType(state, payload) {
        state.costType = payload
    },
    getRateReport(state, payload) {
        state.rateReport = payload
    },
    // HRIS
    getHrisList(state, payload) {
        state.hrisList = payload
    },
    // TIMER LIST
    getTimerList(state, payload) {
        state.timerList = payload
    },
    getTimerListDep(state, payload) {
        state.timerListDep = payload
    },
    getTimerListCas(state, payload) {
      state.timerListCas = payload
    },
    // CALENDAR LIST
    getCalendarList(state, payload) {
        state.calendarList = payload
    },
    // MESSAGES
    getMessagesDirectories(state, payload) {
        state.messagesDirectories = payload
    },
    getMessagesList(state, payload) {
        state.messagesList = payload
    },
    // TEMPLATES PROJECT, TEMPLATES BUSINESS UNIT
    getTemplatesProject(state, payload) {
        state.templatesProject = payload
    },
    getTemplatesBusinessUnit(state, payload) {
        state.templatesBusinessUnit = payload
    },
    getTemplatesEngagement(state, payload) {
      state.templatesEngagement = payload
    },
    setLang(i18n, payload) {
      i18n.locale = payload
    },
    sendErrorLog(state, payload){
       state.sendLog = payload
    },
    loadUser(state, payload) {
      state.user = payload
    },
    setMyFirstCompanys(state, payload) {
      state.myCompanys = payload
    },
    getProjectTeamGridData(state, payload) {
      state.projectTeamGridData = payload
    },
    getTaskTeamGridData(state, payload) {
       state.taskTeamGridData = payload
    },
    getProjectClientsGridData(state, payload) {
       state.projectClientsGridData = payload
    },
    getTaskClientsGridData(state, payload) {
        state.taskClientsGridData = payload
    },
    getProjectVendorsGridData(state, payload) {
        state.projectVendorsData = payload
    },
    getTaskVendorsGridData(state, payload) {
        state.taskVendorsGridData = payload
    },
    getProgressesList(state, payload){
        state.progressData = payload
    },
    getDepProgressesList(state, payload){
        state.depProgressData = payload
    },
    getEngagementProgressesList(state, payload){
      state.engagementProgressData = payload
    },
    // USERS: ROW DATA
    getRowDataUsers(state, payload) {
        state.rowDataUsers = payload
    },
    // VENDORS, CLIENTS: ROW DATA
    getRowDataVendors(state, payload) {
        state.rowDataVendors = payload
    },
    getRowDataClients(state, payload) {
        state.rowDataClients = payload
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA
    getRowDataVendorsPerson(state, payload) {
        state.rowDataVendorsPerson = payload
    },
    getRowDataClientsPerson(state, payload) {
        state.rowDataClientsPerson = payload
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA -> CLEAR
    getRowDataVendorsPersonClear(state, payload) {
        state.rowDataVendorsPerson = payload
    },
    getRowDataClientsPersonClear(state, payload) {
        state.rowDataClientsPerson = payload
    },
    // MENU STATISTICS
    getMenuStatistics(state, payload) {
        state.menuStatistics = payload
    },
    setActiveSubscription(state, payload) {
      state.activeSubscription = payload
    },
    setSubscription(state, payload) {
      state.subscription = payload
    },
    // GET PROJECT FILES
    getProjectFiles(state, payload) {
        state.projecFiles = payload
    },
    getVendorsFiles(state, payload) {
        state.vendorsFiles = payload
    },
    getClientsFiles(state, payload) {
        state.clientsFiles = payload
    },
    // GET TASK FILES
    getTaskFiles(state, payload) {
        state.taskFiles = payload
    },
    getVendorsPersonsFiles(state, payload) {
        state.vendorsPersonsFiles = payload
    },
    getClientsPersonsFiles(state, payload) {
        state.clientsPersonsFiles = payload
    },
    // GET PROJECT COMMENTS
    getProjectComments(state, payload) {
      state.projectComments = payload
    },
    getBusinessUnitComments(state, payload) {
      state.businessUnitComments = payload
    },
    getEngagementComments(state, payload) {
      state.engagementComments = payload
    },
    // GET BUSINESS UNIT TASK COMMENTS
    getBusinessUnitTaskComments(state, payload) {
      state.businessUnitTaskComments = payload
    },
    // GET CASE TASK COMMENTS
    getEngagementTaskComments(state, payload) {
      state.engagementTaskComments = payload
    },
    // GET PROJECT TASK COMMENTS
    getProjectTaskComments(state, payload) {
      state.projectTaskComments = payload
    },
    // GET PROJECT MEETINGS
    getProjectMeetings(state, payload) {
      state.projectMeetings = payload
      console.log('payload', state.projectMeetings)
      for (let i = 0; i < state.projectMeetings.length; i++) {
        for(let b = 0; b < state.projectMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.projectMeetings[i].companyUserList[b].companyUserId && state.projectMeetings[i].companyUserList[b].approved === 0){
            state.projectMeetings[i].notAprroved = true
          }
        }
      }
      // alert(state.companyLayout.companyUserId)
    },
    setMeetings(state, payload) {
      state.meetings = payload
      // const opt = new Map([...state.meetings ,...payload].map(val => [val.id, val]))
      // state.meetings = Array.from(opt.values())
      // state.meetings = [...state.meetings ,...payload]
      for (let i = 0; i < state.meetings.length; i++) {
        for(let b = 0; b < state.meetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.meetings[i].companyUserList[b].companyUserId && state.meetings[i].companyUserList[b].approved === 0){
            state.meetings[i].notAprroved = true
          }
        }
      }
    },
    resetMeetings(state, payload) {
      state.meetings = []
    },
    // GET BUSINESS UNIT MEETINGS
    getBusinessUnitMeetings(state, payload) {
      state.businessUnitMeetings = payload
      console.log('payload', state.businessUnitMeetings)
      for (let i = 0; i < state.businessUnitMeetings.length; i++) {
        for(let b = 0; b < state.businessUnitMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.businessUnitMeetings[i].companyUserList[b].companyUserId && state.businessUnitMeetings[i].companyUserList[b].approved === 0){
            state.businessUnitMeetings[i].notAprroved = true
          }
        }
      }
      // alert(state.companyLayout.companyUserId)
    },
    // GET CASE MEETINGS
    getEngagementMeetings(state, payload) {
      state.engagementMeetings = payload
      console.log('payload', state.engagementMeetings)
      for (let i = 0; i < state.engagementMeetings.length; i++) {
        for(let b = 0; b < state.engagementMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.engagementMeetings[i].companyUserList[b].companyUserId && state.engagementMeetings[i].companyUserList[b].approved === 0){
            state.engagementMeetings[i].notAprroved = true
          }
        }
      }
      // alert(state.companyLayout.companyUserId)
    },
    // GET PROJECT TASK MEETINGS
    getProjectTaskMeetings(state, payload) {
      state.projectTaskMeetings = payload
      console.log('payload', state.projectTaskMeetings)
      for (let i = 0; i < state.projectTaskMeetings.length; i++) {
        for(let b = 0; b < state.projectTaskMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.projectTaskMeetings[i].companyUserList[b].companyUserId && state.projectTaskMeetings[i].companyUserList[b].approved === 0){
            state.projectTaskMeetings[i].notAprroved = true
          }
        }
      }
    },
    // GET BUSINESS UNIT TASK MEETINGS
    getBusinessUnitTaskMeetings(state, payload) {
      state.businessUnitTaskMeetings = payload
      console.log('payload', state.businessUnitTaskMeetings)
      for (let i = 0; i < state.businessUnitTaskMeetings.length; i++) {
        for(let b = 0; b < state.businessUnitTaskMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.businessUnitTaskMeetings[i].companyUserList[b].companyUserId && state.businessUnitTaskMeetings[i].companyUserList[b].approved === 0){
            state.businessUnitTaskMeetings[i].notAprroved = true
          }
        }
      }
    },
    // GET CASE TASK MEETINGS
    getEngagementTaskMeetings(state, payload) {
      state.engagementTaskMeetings = payload;
      console.log('payload', state.engagementTaskMeetings);
      for (let i = 0; i < state.engagementTaskMeetings.length; i++) {
        for(let b = 0; b < state.engagementTaskMeetings[i].companyUserList.length; b++){
          if(state.companyLayout.companyUserId === state.engagementTaskMeetings[i].companyUserList[b].companyUserId && state.engagementTaskMeetings[i].companyUserList[b].approved === 0){
            state.engagementTaskMeetings[i].notAprroved = true
          }
        }
      }
    },
    getPurchaseList(state, payload){
      state.purchaseList = payload
    },
    getPurchaseOrderList(state, payload){
      state.purchaseOrderList = payload
    },
    setInventoryManager(state, payload){
      state.isInventoryManager = payload
    },
    // GET BUSINESS UNIT FILES
    getBusinessUnitFiles(state, payload) {
      state.businessUnitFiles = payload
    },
    // GET CASE FILES
    getEngagementFiles(state, payload) {
      state.engagementFiles = payload
    },
    // GET BUSINESS UNIT TASK FILES
    getDepTaskFiles(state, payload) {
      state.depTaskFiles = payload
    },
    getCasTaskFiles(state, payload) {
      state.casTaskFiles = payload
    },
    // NEWS MENU
    getNewsMenu(state, payload) {
      state.newsMenu = payload
    },
    // GET PROJECT HISTORY
    getProjectHistory(state, payload) {
      state.projectHistory = payload
    },
    // GET PROJECT TASK HISTORY
    getProjectTaskHistory(state, payload) {
      state.projectTaskHistory = payload
    },
    // GET BUSINESS UNIT HISTORY
    getBusinessUnitHistory(state, payload) {
      state.businessUnitHistory = payload
    },
    // GET CASE HISTORY
    getEngagementHistory(state, payload) {
      state.engagementHistory = payload
    },
    // GET BUSINESS UNIT TASK HISTORY
    getBusinessUnitTaskHistory(state, payload) {
      state.businessUnitTaskHistory = payload
    },
    // GET CASE TASK HISTORY
    getEngagementTaskHistory(state, payload) {
      state.engagementTaskHistory = payload
    },
    // GET USER HISTORY
    getUserHistory(state, payload) {
      state.userHistory = payload
    },
    //sideBarStatus
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
    },
    //ActiveCompanyName
    TOGGLE_ACTIVE_COMPANY_NAME(state, payload) {
      state.activeCompanyName = payload
    },
    hideFileNotification(state, payload){
      state.notificationDuration = payload
    }
  },
  getters: {
    // quotation
    getQuotationList: state => {
      return state.quotationList
    },
    // material
    getProjectMaterialDirectories: state => {
      return state.projectMaterialDirectories
    },
    getProjectMaterialItem: state => {
      return state.projectMaterialItem
    },
    // material project
    getProjectMaterialDirectoriesProj: state => {
      return state.projectMaterialDirectoriesProj
    },
    getProjectMaterialItemProj: state => {
      return state.projectMaterialItemProj
    },
    // documents
    getDocuments: state => {
      return state.documents;
    },
    getDocumentsBU: state => {
      return state.documentsBU;
    },
    getDocumentsE: state => {
      return state.documentsE;
    },
    // USERS: ROW DATA
    getRowDataUsers: state => {
        return state.rowDataUsers;
    },
    // VENDORS, CLIENTS: ROW DATA
    getRowDataVendors: state => {
        return state.rowDataVendors;
    },
    getRowDataClients: state => {
        return state.rowDataClients;
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA
    getRowDataVendorsPerson: state => {
        return state.rowDataVendorsPerson;
    },
    getRowDataClientsPerson: state => {
        return state.rowDataClientsPerson;
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA -> CLEAR
    getRowDataVendorsPersonClear: state => {
        return state.rowDataVendorsPerson;
    },
    getRowDataClientsPersonClear: state => {
        return state.rowDataClientsPerson;
    },
    // MENU STATISTICS
    getMenuStatistics: state => {
        return state.menuStatistics;
    },
    // TEMPLATES PROJECT, TEMPLATES BUSINESS UNIT
    getTemplatesProject: state => {
        return state.templatesProject;
    },
    getTemplatesBusinessUnit: state => {
        return state.templatesBusinessUnit;
    },
    getTemplatesEngagement: state => {
      return state.templatesEngagement;
    },
    // MESSAGES
    getMessagesDirectories: state => {
        return state.messagesDirectories;
    },
    getMessagesList: state => {
        return state.messagesList;
    },
    // NEWS MENU
    getNewsMenu: state => {
        return state.newsMenu;
    },
    // CALENDAR LIST
    getCalendarList: state => {
        return state.calendarList;
    },
    // TIMER LIST
    getTimerList: state => {
        return state.timerList;
    },
    getTimerListDep: state => {
        return state.timerListDep;
    },
    getTimerListCas: state => {
      return state.timerListCas;
    },
    // HRIS
    getHrisList: state => {
        return state.hrisList;
    },
    // Rate
    getCostType: state => {
        return state.costType;
    },
    getRateReport: state => {
        return state.rateReport;
    },
    // Invoices
    getInvoicesList: state => {
        return state.invoicesList;
    },
    // Invoice Item
    getInvoiceItem: state => { return state.invoiceItem},
    // Business Unit Project List
    getBusinessUnitProjectsList: state => { return state.businessUnitProjectsList },
    getBusinessUnitEngagementList: state => { return state.businessUnitEngagementsList },
    getProjectPermissionsList: state => { return state.projectUsersPermissions },
    getEngagementPermissionsList: state => { return state.engagementUsersPermissions },
    getBusinessUnitPermissionsList: state => { return state.businessUnitUsersPermissions },
    // Directories create invoices
    getDirectoriesCreateInvoices: state => { return state.directoriesCreateInvoices },
    // Company Layout
    getCompanyLayout: state => state.companyLayout,
    getPurchaseList: state => state.purchaseList,
    getPurchaseOrderList: state => state.purchaseOrderList,
    setInventoryManager: state => state.isInventoryManager,
    getNotificationDuration: state => state.notificationDuration,
    getViewerSettings: state => state.viewerSettings,
    getActiveSubscription: state => state.activeSubscription,
    getSubscription: state => state.subscription
  },
  actions: {
    // quotation
    getQuotationList(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/project-invoice/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
          .then(response => {
              console.log('---/project-invoice/list', response.data.item);

              context.commit('getQuotationList', response.data.item);
            loader.hide()
          })
          .catch(error => {
              console.log('An error occurred:', error);
            loader.hide()
          });
    },
    // material
    getProjectMaterialDirectories(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/materials/directories?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&taskId=${index.id}&operation=${index.operation}`)
        .then(response => {
          console.log('/materials/directories', response.data)
          context.commit('getProjectMaterialDirectories', response.data)

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/materials/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&taskId=${router.history.current.query.taskId}`)
                  .then(response => {
                    loader.hide();
                    console.log('---/materials/list', response.data)
                    // this.tooltipUser = response.data.fieldInfo.user
                    context.commit('getProjectMaterialItem', response.data)
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    // material project
    getProjectMaterialDirectoriesProj(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/project-materials/directories?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&operation=${index.operation}`)
        .then(response => {
          console.log('/materials/directories', response.data)
          context.commit('getProjectMaterialDirectoriesProj', response.data)

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/project-materials/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
                  .then(response => {
                    loader.hide();
                    console.log('---/materials/list', response.data)
                    context.commit('getProjectMaterialItemProj', response.data)
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    // documents
    getDocuments(context, index){
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/documents/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${index}`)
          .then(response => {
            loader.hide();
            console.log('/projectTasks/documents', response.data);
            context.commit('getDocuments', response.data);
            resolve(response.data)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getDocumentsBU(context, index){
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTasks/documents/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${index}`)
          .then(response => {
            console.log('/businessUnitTasks/documents/', response.data);
            context.commit('getDocumentsBU', response.data);
            resolve(response.data);
            loader.hide();
          })
          .catch(error => {
            console.log('An error occurred:', error);
            reject(error);
            loader.hide();
          });
      });
    },
    getDocumentsE(context, index){
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/documents/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${index}`)
          .then(response => {
            console.log('/engagementTasks/documents', response.data);
            context.commit('getDocumentsE', response.data);
            resolve(response.data);
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            reject(error);
            loader.hide()
          });
      });
    },
    setLang(context, payload) {
      console.log('payload', payload)
      context.commit('setLang', payload)
    },
    sendErrorLog(context, payload){
      console.log('sendErrorLog')
      const loader = app.loading.show();
      axios
        .post('/api/v1/mainLayout/getData')
        .then(response => {
          console.log('---', response.data);
          context.commit('loadUser', response.data);
          loader.hide()
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
          if (error.response.data.message === "invalid_email_value") {
            localStorage.clear()
            router.push('/login')
          }
        });
    },
    loadUser(context, payload) {
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post('/api/v1/mainLayout/getData')
          .then(response => {
            response.data.companyList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });
            context.commit('loadUser', response.data);
            resolve(response.data);
            loader.hide()
          }, error =>{
            loader.hide();
            console.log('An error occurred:', error);
            if (error.response.data.message === "invalid_email_value") {
              localStorage.clear()
              router.push('/login')
            }
            reject(error)
          })
      })
    },
    companyChange(context, payload){
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/mainLayout/companyChanged?newCompanyId=${payload}`)
          .then(response => {
            loader.hide();
            resolve('ok')
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      })
    },
    projectChange(context, payload){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companyLayout/projectChanged?companyId=${router.history.current.query.companyId}&newProjectId=${payload}`)
        .then(response => {
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          console.log('An error occurred:', error);
        });
    },
    setMyFirstCompanys(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post('/api/v1/mainLayout/getData')
          .then(response => {
            console.log('--COMPANIES--', response.data.companyList);
            if (!localStorage.getItem('companyId')) {
              console.log('--COMPANIES IF LOCAL EMPTY--', response.data.companyList);
              localStorage.setItem('companyId', response.data.companyList[0].id);
              // localStorage.setItem('companyName', response.data.companyList[0].name);
            }
            var lastLoginId = response.data.companyList[0].id;
            // Last login
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/companyUsers/companyChanged?newCompanyId=${lastLoginId}`)
                .then(response => {
                  loader.hide()
                })
                .catch(error => {
                  loader.hide()
                  console.log('An error occurred:', error);
                });
            context.commit('setMyFirstCompanys', response.data.companyList);
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    // INFO TABS START
    getProjectTeamGridData(context, payload){
            const loader = app.loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectUsers/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&level=3`)
                .then(response => {
                  loader.hide();
                    const result = [];
                    for (let i = 0; i < response.data.list.length; i++){
                        result.push(response.data.list[i].companyUser);
                        context.commit('getProjectTeamGridData', result);
                    }
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
    },
    getTaskTeamGridData(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTaskUsers/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${index}&level=3`)
            .then(response => {
              loader.hide();
                const result = [];
                for (let i = 0; i < response.data.list.length; i++){
                    result.push(response.data.list[i].companyUser);
                    context.commit('getTaskTeamGridData', result);
                }
            })
            .catch(error => {
              loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getProjectClientsGridData(context, payload){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectClients/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
          .then(response => {
            loader.hide();
             const result = [];
             for (let i = 0; i < response.data.list.length; i++){
                result.push(response.data.list[i].companyClient);
                context.commit('getProjectClientsGridData', result);
             }
          })
          .catch(error => {
            loader.hide();
             console.log('An error occurred:', error);
          });
    },
    getTaskClientsGridData(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTaskClients/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${index}`)
            .then(response => {
              loader.hide();
                const result = [];
                for (let i = 0; i < response.data.list.length; i++){
                    result.push(response.data.list[i].companyClient);
                    context.commit('getTaskClientsGridData', result);
                }
            })
            .catch(error => {
              loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getProjectVendorsGridData(context, payload){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectVendors/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
                .then(response => {
                  loader.hide();
                    const result = [];
                    for (let i = 0; i < response.data.list.length; i++){
                        result.push(response.data.list[i].companyVendor);
                        context.commit('getProjectVendorsGridData', result);
                    }
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
    },
    getTaskVendorsGridData(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTaskVendors/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${index}`)
            .then(response => {
              loader.hide();
                const result = [];
                // console.log("RESPONSE", response.data.list)
                for (let i = 0; i < response.data.list.length; i++){
                    result.push(response.data.list[i].companyVendor);
                    context.commit('getTaskVendorsGridData', result);
                }
            })
            .catch(error => {
              loader.hide();
                console.log('An error occurred:', error);
            });
    },
    // INFO TABS END
    getProgressesList(context, payload){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskProgresses/list?companyId=${router.history.current.query.companyId}&projectId=${payload.projectId}&projectTaskId=${payload.taskId}`)
          .then(response => {
            loader.hide();
            console.log('SELECTED PROGRESS LIST', response.data.list);

            let list = response.data.list;

            for (let i = 0; i < list.length; i++ ){
              list[i].time = response.data.timestamp;
              if (i == 0) {
                if (!list[0].isTimer && list[0].actionType === 1) {
                  list[0].showBTN = true
                }
              }
              if (i == 1) {
                if (!list[1].isTimer && list[1].actionType === 1) {
                  list[1].showBTN = true
                }
              }
            }

            context.commit('getProgressesList', response.data.list);
            resolve(response.data.list)
            // this.progressData = response.data.list
            // if(response.data.list.length === 0){
            //     this.isOnProgress = true
            // }else{
            //     this.isOnProgress = false
            // }
          })
          .catch(error => {
            loader.hide();
            reject(error);
            // if (error.response.data.statusCode == 401) {
            //     localStorage.clear();
            //     router.push('/login')
            // }
            console.log('An error occurred:', error);
          });
        // this.$refs.filterProgressButtons.filter()
      });
    },
    //INFO TAB DEP
    getDepProgressesList(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskProgresses/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${index}`)
          .then(response => {
            loader.hide();
            console.log('SELECTED PROGRESS LIST BUSINESS UNITS', response.data.list);
            context.commit('getDepProgressesList', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            reject(error);
            console.log('An error occurred:', error);
          });
      });
    },
    //INFO TAB CASE
    getEngagementProgressesList(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTaskProgresses/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${index}`)
          .then(response => {
            loader.hide();
            console.log('SELECTED PROGRESS LIST CASE', response.data.list);
            context.commit('getEngagementProgressesList', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    // USERS: ROW DATA
    getRowDataUsers(context, payload) {
      const loader = app.loading.show();
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
        .post(`/api/v1/companyUsers/list?companyId=${router.history.current.query.companyId}`)
        .then(response => {
          loader.hide();
            console.log('---/companyUsers/list9999999999999999999999999', response.data);
            let list = [];
            for (let i = 0; i < response.data.list.length; i++) {
              if(response.data.list[i].isAccountant === 1){
                response.data.list[i].isAccountant = true
              }else{
                response.data.list[i].isAccountant = false
              }
              if(response.data.list[i].isChequeReceipts === 1){
                response.data.list[i].isChequeReceipts = true
              } else {
                response.data.list[i].isChequeReceipts = false
              }
              let timezone =response.data.list[i].user.timezone
              // alert(response.data.list[i].user.id)
              if (timezone) {
                list.push({
                  id: i + 1,
                  userId: response.data.list[i].id,
                  uId: response.data.list[i].user.id,
                  name: response.data.list[i].user.fullName,
                  email: response.data.list[i].user.email,
                  businessUnits: response.data.list[i].businessUnit ? response.data.list[i].businessUnit.name : '',
                  leader: response.data.list[i].leader,
                  role: response.data.list[i].companyUserGroup.name,
                  lastLogin: (response.data.list[i].lastLoginDate) ? moment(response.data.list[i].lastLoginDate * 1000).format("D MMM YY, h:mm a") : '',
                  status: response.data.list[i].status,
                  address: response.data.list[i].user.address,
                  work_phone: response.data.list[i].user.workPhone,
                  home_phone: response.data.list[i].user.homePhone,
                  phone: response.data.list[i].user.phone,
                  company: response.data.list[i].user.company,
                  avatarUrl: response.data.list[i].user.avatarUrl,
                  isAccountant: response.data.list[i].isAccountant,
                  isChequeReceipts: response.data.list[i].isChequeReceipts,
                  isInventoryManager: response.data.list[i].isInventoryManager === 1,
                  timezoneId: response.data.list[i].user.timezone.name + ' (' + response.data.list[i].user.timezone.gmtOffsetName + ')',
                  mailNotifications: response.data.list[i].user.mailNotifications,
                  companyEmail: response.data.list[i].user.companyEmail,
                  isDocumentManager: response.data.list[i].isDocumentManager,
                })
              } else {
                list.push({
                  id: i + 1,
                  userId: response.data.list[i].id,
                  uId: response.data.list[i].user.id,
                  name: response.data.list[i].user.fullName,
                  email: response.data.list[i].user.email,
                  businessUnits: response.data.list[i].businessUnit ? response.data.list[i].businessUnit.name : '',
                  leader: response.data.list[i].leader,
                  role: response.data.list[i].companyUserGroup.name,
                  lastLogin: (response.data.list[i].lastLoginDate) ? moment(response.data.list[i].lastLoginDate * 1000).format("D MMM YY, h:mm a") : '',

                  status: response.data.list[i].status,
                  address: response.data.list[i].user.address,
                  work_phone: response.data.list[i].user.workPhone,
                  home_phone: response.data.list[i].user.homePhone,
                  phone: response.data.list[i].user.phone,
                  company: response.data.list[i].user.company,
                  avatarUrl: response.data.list[i].user.avatarUrl,
                  isAccountant: response.data.list[i].isAccountant,
                  isChequeReceipts: response.data.list[i].isChequeReceipts,
                  isInventoryManager: response.data.list[i].isInventoryManager === 1,
                  timezoneId: "",
                  mailNotifications: response.data.list[i].user.mailNotifications,
                  companyEmail: response.data.list[i].user.companyEmail,
                  isDocumentManager: response.data.list[i].isDocumentManager,
                })
              }
            }

            context.commit('getRowDataUsers', list);
            resolve(list)
        })
        .catch(error => {
          loader.hide();
            // if (error.response.data.statusCode == 401) {
            // localStorage.clear()
            // router.push('/login')
            // }
            console.log('An error occurred:', error);
            reject(error)
        });
      })
    },
    // VENDORS, CLIENTS: ROW DATA
    getRowDataVendors(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
        .get(`/api/v1/client-vendor?companyId=${router.history.current.query.companyId}&entityType=vendor&id=null`)
        .then(response => {
          loader.hide();
            console.log('---/companyVendors/list', response.data);

            let list = [];
            for (let i = 0; i < response.data.result.length; i++) {
              list.push({
                  // General
                  id: i + 1,
                  vendorId: response.data.result[i].companyVendorId ? response.data.result[i].companyVendorId : response.data.result[i].id,
                  personId: response.data.result[i].companyVendorId ? response.data.result[i].id : null,
                  filePath: response.data.result[i].filePath,
                  name: response.data.result[i].name || response.data.result[i].fullName,
                  fullName: response.data.result[i].fullName,
                  shortName: response.data.result[i].shortName,
                  email: response.data.result[i].email,
                  website: response.data.result[i].website,
                  linkedIn: response.data.result[i].linkedIn || response.data.result[i].linkedin,
                  facebook: response.data.result[i].facebook,
                  phone: response.data.result[i].phone || null,
                  fax: response.data.result[i].fax,
                  managerId: response.data.result[i].managerId,
                  shippingMethodId: response.data.result[i].shippingMethodId,
                  assignSupplyChainMgr: response.data.result[i].manager ? response.data.result[i].manager.fullName : null,
                  shippingMethod: response.data.result[i].shippingMethod ? response.data.result[i].shippingMethod.name : null,
                  type: response.data.result[i].companyVendorId ? 'person' : 'vendor',
                  tagAs: response.data.result[i].tagAs || null,

                  firstname: response.data.result[i].firstname || null,
                  lastname: response.data.result[i].lastname || null,
                  skype: response.data.result[i].skype || null,
                  workPhone: response.data.result[i].workPhone || null,
                  mobilePhone: response.data.result[i].mobilePhone || null,
                  primaryContact: response.data.result[i].primaryContact || null,
                  position: response.data.result[i].position || null,
                  department: response.data.result[i].department || null,

                  // Address
                  addresses: response.data.result[i].addresses || null,

                  country: response.data.result[i].country || null,
                  state: response.data.result[i].state || null,
                  city: response.data.result[i].city || null,
                  postCode: response.data.result[i].postCode || null,
                  addressLine1: response.data.result[i].address || null,
                  addressLine2: response.data.result[i].address2 || null,
                  addressLine3: response.data.result[i].address3 || null,

                  // // Finance
                  // finance: response.data.result[i].finance || null,

                  // // Canvass
                  // canvas: response.data.result[i].canvas || null,

                  // // Custom
                  // custom: response.data.result[i].custom || null,

                  // // Expanded
                  // expanded: response.data.result[i].expanded || null,

                  businessUnitList: response.data.result[i].entityData ? response.data.result[i].entityData.businessUnitTaskList : [],
                  engagementList: response.data.result[i].entityData ? response.data.result[i].entityData.engagementTaskList : [],
                  projectList: response.data.result[i].entityData ? response.data.result[i].entityData.projectTaskList : [],

                  dateCreated: moment(response.data.result[i].createDate * 1000).format("D MMM YY"),
              })
            }

            context.commit('getRowDataVendors', list);
        })
        .catch(error => {
          loader.hide();
            // if (error.response.data.statusCode == 401) {
            // localStorage.clear()
            // router.push('/login')
            // }
            console.log('An error occurred:', error);
        });
    },
    getRowDataClients(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/client-vendor?companyId=${router.history.current.query.companyId}&entityType=client&id=null`)
        .then(response => {
          loader.hide();
          console.log('---/companyClients/list', response.data);

          let list = [];
          for (let i = 0; i < response.data.result.length; i++) {
            list.push({
                // General
                id: i + 1,
                vendorId: response.data.result[i].companyClientId ? response.data.result[i].companyClientId : response.data.result[i].id,
                personId: response.data.result[i].companyClientId ? response.data.result[i].id : null,
                filePath: response.data.result[i].filePath,
                name: response.data.result[i].name || response.data.result[i].fullName,
                fullName: response.data.result[i].fullName,
                shortName: response.data.result[i].shortName,
                email: response.data.result[i].email,
                website: response.data.result[i].website,
                linkedIn: response.data.result[i].linkedIn || response.data.result[i].linkedin,
                facebook: response.data.result[i].facebook,
                phone: response.data.result[i].phone || null,
                fax: response.data.result[i].fax,
                managerId: response.data.result[i].managerId,
                shippingMethodId: response.data.result[i].shippingMethodId,
                assignSupplyChainMgr: response.data.result[i].manager ? response.data.result[i].manager.fullName : null,
                shippingMethod: response.data.result[i].shippingMethod ? response.data.result[i].shippingMethod.name : null,
                type: response.data.result[i].companyClientId ? 'person' : 'client',
                tagAs: response.data.result[i].tagAs || null,

                firstname: response.data.result[i].firstname || null,
                lastname: response.data.result[i].lastname || null,
                skype: response.data.result[i].skype || null,
                workPhone: response.data.result[i].workPhone || null,
                mobilePhone: response.data.result[i].mobilePhone || null,
                primaryContact: response.data.result[i].primaryContact || null,
                position: response.data.result[i].position || null,
                department: response.data.result[i].department || null,
                // Address
                addresses: response.data.result[i].addresses || null,

                country: response.data.result[i].country || null,
                state: response.data.result[i].state || null,
                city: response.data.result[i].city || null,
                postCode: response.data.result[i].postCode || null,
                addressLine1: response.data.result[i].address || null,
                addressLine2: response.data.result[i].address2 || null,
                addressLine3: response.data.result[i].address3 || null,

                // // Finance
                // finance: response.data.result[i].finance || null,

                // // Assessment
                // assessment: response.data.result[i].assessment || null,

                // // Custom
                // custom: response.data.result[i].custom || null,

                // // Expanded
                // expanded: response.data.result[i].expanded || null,

                businessUnitList: response.data.result[i].entityData ? response.data.result[i].entityData.businessUnitTaskList : [],
                engagementList: response.data.result[i].entityData ? response.data.result[i].entityData.engagementTaskList : [],
                projectList: response.data.result[i].entityData ? response.data.result[i].entityData.projectTaskList : [],

                dateCreated: moment(response.data.result[i].createDate * 1000).format("D MMM YY"),
            })
          }

          context.commit('getRowDataClients', list);
        })
        .catch(error => {
          loader.hide();
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear()
          //   router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA
    getRowDataVendorsPerson(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyVendorPersons/list?companyId=${router.history.current.query.companyId}&companyVendorId=${router.history.current.query.companyVendorId}`)
            .then(response => {
              loader.hide();
                console.log('---/companyVendorPersons/list', response.data);

                let list = [];
                for (let i = 0; i < response.data.list.length; i++) {
                    let country = null
                    let state = null
                    let city = null
                    if (response.data.list[i].country) {
                      country = response.data.list[i].country.name
                      state = response.data.list[i].state.name
                      city = response.data.list[i].city.name
                    }

                    list.push({
                    id: i + 1,
                    vendorPersonId: response.data.list[i].id,
                    firstName: response.data.list[i].firstname,
                    lastName: response.data.list[i].lastname,
                    name: response.data.list[i].firstname + ' ' + response.data.list[i].lastname,
                    email: response.data.list[i].email,
                    country: country,
                    state: state,
                    city: city,
                    isAddressAssigned: response.data.list[i].isAddressAssigned,
                    address: response.data.list[i].address,
                    address2: response.data.list[i].address2,
                    address3: response.data.list[i].address3,
                    postCode: response.data.list[i].postCode,
                    workPhone: response.data.list[i].workPhone,
                    phone: response.data.list[i].mobilePhone,
                    skype: response.data.list[i].skype,
                    facebook: response.data.list[i].facebook,
                    linkedIn: response.data.list[i].linkedin,
                    })
                }

                context.commit('getRowDataVendorsPerson', list);
            })
            .catch(error => {
              loader.hide();
            console.log('An error occurred:', error);
            });
    },
    getRowDataClientsPerson(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/companyClientPersons/list?companyId=${router.history.current.query.companyId}&companyClientId=${router.history.current.query.companyClientId}`)
            .then(response => {
              loader.hide();
                console.log('---/companyClientPersons/list', response.data);

                let list = [];
                for (let i = 0; i < response.data.list.length; i++) {
                    let country = null
                    let state = null
                    let city = null
                    if (response.data.list[i].country) {
                      country = response.data.list[i].country.name
                      state = response.data.list[i].state.name
                      city = response.data.list[i].city.name
                    }

                    list.push({
                    id: i + 1,
                    clientPersonId: response.data.list[i].id,
                    firstName: response.data.list[i].firstname,
                    lastName: response.data.list[i].lastname,
                    name: response.data.list[i].firstname + ' ' + response.data.list[i].lastname,
                    email: response.data.list[i].email,
                    country: country,
                    state: state,
                    city: city,
                    isAddressAssigned: response.data.list[i].isAddressAssigned,
                    address: response.data.list[i].address,
                    address2: response.data.list[i].address2,
                    address3: response.data.list[i].address3,
                    postCode: response.data.list[i].postCode,
                    workPhone: response.data.list[i].workPhone,
                    phone: response.data.list[i].mobilePhone,
                    skype: response.data.list[i].skype,
                    facebook: response.data.list[i].facebook,
                    linkedIn: response.data.list[i].linkedin,
                    })
                }

                context.commit('getRowDataClientsPerson', list);
            })
            .catch(error => {
              loader.hide();
            console.log('An error occurred:', error);
            });
    },
    // VENDORS PERSON, CLIENTS PERSON: ROW DATA -> CLEAR
    getRowDataVendorsPersonClear(context, payload) {
        context.commit('getRowDataVendorsPersonClear', []);
    },
    getRowDataClientsPersonClear(context, payload) {
        context.commit('getRowDataClientsPersonClear', []);
    },
    // MENU STATISTICS
    getMenuStatistics(context, payload) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/companyLayout/getData?companyId=${payload || router.history.current.query.companyId}`)
            .then(response => {
                console.log('---/companyLayout/getData', response.data.stats);
                context.commit('getMenuStatistics', response.data.stats);
                resolve(response.data)
            }, error => {
              reject(error)
            })
      })
    },
    getProjectFiles(context) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .post(`/api/v1/projectFiles/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
          .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.projectId}&entityTypeId=3`)
          .then(response => {
            loader.hide();
            console.log('---Project Files', response.data.list);
            const list = response.data.list.map(val => ({ ...val, isEditNow: false })).reverse()

            context.commit('getProjectFiles', list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      })
    },
    getVendorsFiles(context) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.companyVendorId}&entityTypeId=60`)
            .then(response => {
              loader.hide();
              context.commit('getVendorsFiles', response.data.list);
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      })
    },
    getClientsFiles(context) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.companyClientId}&entityTypeId=85`)
            .then(response => {
              loader.hide();
              context.commit('getClientsFiles', response.data.list);
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
      })
    },
    getTaskFiles(context, index) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .post(`/api/v1/projectTaskFiles/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${index}`)
          .get(`/api/v1/entityFiles/list?entityId=${index}&entityTypeId=27`)
          .then(response => {
            console.log('project task files', response.data.list)
            loader.hide();
            const list = response.data.list.map(val => ({ ...val, isEditNow: false })).reverse()

            context.commit('getTaskFiles', list);
            resolve(list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    getVendorsPersonsFiles(context, index) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.companyVendorPersonId}&entityTypeId=61`)
            .then(response => {
              loader.hide();
              context.commit('getVendorsPersonsFiles', response.data.list);
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
              reject(error)
            });
      })
    },
    getClientsPersonsFiles(context, index) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.companyClientPersonId}&entityTypeId=86`)
            .then(response => {
              loader.hide();
              context.commit('getClientsPersonsFiles', response.data.list);
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
              reject(error)
            });
      })
    },
    getBusinessUnitFiles(context) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .post(`/api/v1/businessUnitFiles/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}`)
          .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.businessUnitId}&entityTypeId=19`)
          .then(response => {
            console.log('---P', response.data);
            loader.hide();
            const list = response.data.list.map(val => ({ ...val, isEditNow: false }))

            context.commit('getBusinessUnitFiles', list)
            resolve(list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    getEngagementFiles(context) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .post(`/api/v1/engagementFiles/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}`)
          .get(`/api/v1/entityFiles/list?entityId=${router.history.current.query.engagementId}&entityTypeId=11`)
          .then(response => {
            loader.hide();
            console.log('---P', response.data);
            const list = response.data.list.map(val => ({ ...val, isEditNow: false }))

            context.commit('getEngagementFiles', list);
            resolve(list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
      getDepTaskFiles(context, index) {
        return new Promise ((resolve, reject) => {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            // .post(`/api/v1/businessUnitTaskFiles/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${index}`)
            .get(`/api/v1/entityFiles/list?entityId=${index}&entityTypeId=45`)
            .then(response => {
              loader.hide();
              console.log('---/businessUnitTaskFiles/list', response.data.list);
              const list = response.data.list.map(val => ({ ...val, isEditNow: false }))

              context.commit('getDepTaskFiles', list);
              resolve(list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        })
      },
    getCasTaskFiles(context, index) {
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          // .post(`/api/v1/engagementTaskFiles/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${index}`)
          .get(`/api/v1/entityFiles/list?entityId=${index}&entityTypeId=36`)
          .then(response => {
            loader.hide();
            const list = response.data.list.map(val => ({ ...val, isEditNow: false }))
            console.log('---/engagementTaskFiles/list', response.data);
            context.commit('getCasTaskFiles', list);
            resolve(list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    getProjectComments(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectComments/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
          .then(response => {
            loader.hide();
            console.log('PROJECT COMMENTS', response.data.list);
            context.commit('getProjectComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getProjectTaskComments(context, payload){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskComments/list?companyId=${router.history.current.query.companyId}&projectId=${payload.projectId}&projectTaskId=${payload.taskId}`)
          .then(response => {
            loader.hide();
            console.log('PROJECT TASK COMMENTS', response.data.list);
            context.commit('getProjectTaskComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getBusinessUnitComments(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitComments/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}`)
          .then(response => {
            loader.hide();
            console.log('BUSINESS UNIT COMMENTS', response.data.list);
            context.commit('getBusinessUnitComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getEngagementComments(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementComments/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}`)
          .then(response => {
            loader.hide();
            console.log('BUSINESS UNIT COMMENTS', response.data.list);
            context.commit('getEngagementComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getBusinessUnitTaskComments(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskComments/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${index}`)
          .then(response => {
            loader.hide();
            console.log('BUSINESS UNIT TASK COMMENTS', response.data.list);
            context.commit('getBusinessUnitTaskComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getEngagementTaskComments(context, index){
      return new Promise ((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTaskComments/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${index}`)
          .then(response => {
            loader.hide();
            console.log('CASE TASK COMMENTS', response.data.list);
            context.commit('getEngagementTaskComments', response.data.list);
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      });
    },
    getProjectMeetings(context, proectId){
      return new Promise ((resolve, reject )=> {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectMeetings/list?companyId=${router.history.current.query.companyId}&projectId=${proectId || router.history.current.query.projectId}&taskId=null&typeId=1`)
          .then(response => {
            loader.hide();
            context.commit('getProjectMeetings', response.data.list)
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    getMeetings(context, payload) {
      return new Promise ((resolve, reject )=> {
        // if (!payload.page || payload.page == 1) {
        //   context.commit('resetMeetings')
        // }
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/meetings/list?companyId=${payload.companyId || router.history.current.query.companyId}&parentId=${payload.parentId}&taskId=${payload.taskId}&typeId=${payload.typeId}&page=${payload.page}`)
            .then(response => {
              loader.hide();
              context.commit('setMeetings', response.data.list)
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
              reject(error)
            });
      })
    },
    getBusinessUnitMeetings(context, businessUnitId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessUnitMeetings/list?companyId=${router.history.current.query.companyId}&businessUnitId=${businessUnitId || router.history.current.query.businessUnitId}`)
        .then(response => {
          loader.hide();
          console.log('businessUnit Meetings', response.data.list)
          // response.data.list.forEach(val=>{
          //   if (val.startDate.toString().length < 8) {
          //     val.startDate = '0' + val.startDate.toString()
          //   } else {
          //     val.startDate = val.startDate.toString()
          //   }
          //   if (val.startTime.toString().length < 4) {
          //     val.startTime = '0' + val.startTime.toString()
          //   } else {
          //     val.startTime = val.startTime.toString()
          //   }
          // })
          context.commit('getBusinessUnitMeetings', response.data.list)
        })
        .catch(error => {
          loader.hide();
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear();
          //   router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
      // this.$refs.filterProgressButtons.filter()
    },
    getEngagementMeetings(context, engagementId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/engagementMeetings/list?companyId=${router.history.current.query.companyId}&engagementId=${engagementId || router.history.current.query.engagementId}`)
        .then(response => {
          loader.hide()
          console.log('engagement Meetings', response.data.list)
          // response.data.list.forEach(val=>{
          //   if (val.startDate.toString().length < 8) {
          //     val.startDate = '0' + val.startDate.toString()
          //   } else {
          //     val.startDate = val.startDate.toString()
          //   }
          //   if (val.startTime.toString().length < 4) {
          //     val.startTime = '0' + val.startTime.toString()
          //   } else {
          //     val.startTime = val.startTime.toString()
          //   }
          // })
          context.commit('getEngagementMeetings', response.data.list)
        })
        .catch(error => {
          loader.hide();
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear();
          //   router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
      // this.$refs.filterProgressButtons.filter()
    },
    getProjectTaskMeetings(context, data){
      return new Promise((resolve, reject) => {
        const loader = app.loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskMeetings/list?companyId=${router.history.current.query.companyId}&projectId=${data.projectId || router.history.current.query.projectId}&projectTaskId=${data.taskId}`)
            .then(response => {
              loader.hide();
              console.log('PROJECT Meetings', response.data.list)
              context.commit('getProjectTaskMeetings', response.data.list)
              resolve(response.data.list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
              reject(error)
            });
      })
    },
    getBusinessUnitTaskMeetings(context, data){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessUnitTaskMeetings/list?companyId=${router.history.current.query.companyId}&businessUnitId=${data.businessUnitId || router.history.current.query.businessUnitId}&businessUnitTaskId=${data.taskId|| router.history.current.query.taskId}`)
        .then(response => {
          loader.hide();
          console.log('businessUnit Meetings', response.data.list)
          // response.data.list.forEach(val=>{
          //   if (val.startDate.toString().length < 8) {
          //     val.startDate = '0' + val.startDate.toString()
          //   } else {
          //     val.startDate = val.startDate.toString()
          //   }
          //   if (val.startTime.toString().length < 4) {
          //     val.startTime = '0' + val.startTime.toString()
          //   } else {
          //     val.startTime = val.startTime.toString()
          //   }
          // })
          context.commit('getBusinessUnitTaskMeetings', response.data.list)
        })
        .catch(error => {
          loader.hide();
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear();
          //   router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
      // this.$refs.filterProgressButtons.filter()
    },
    getEngagementTaskMeetings(context, data){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/engagementTaskMeetings/list?companyId=${router.history.current.query.companyId}&engagementId=${data.engagementId || router.history.current.query.engagementId}&engagementTaskId=${data.taskId}`)
        .then(response => {
          loader.hide();
          console.log('engagement Meetings', response.data.list)
          // response.data.list.forEach(val=>{
          //   if (val.startDate.toString().length < 8) {
          //     val.startDate = '0' + val.startDate.toString()
          //   } else {
          //     val.startDate = val.startDate.toString()
          //   }
          //   if (val.startTime.toString().length < 4) {
          //     val.startTime = '0' + val.startTime.toString()
          //   } else {
          //     val.startTime = val.startTime.toString()
          //   }
          // })
          context.commit('getEngagementTaskMeetings', response.data.list)
        })
        .catch(error => {
          loader.hide();
          // if (error.response.data.statusCode == 401) {
          //   localStorage.clear();
          //   router.push('/login')
          // }
          console.log('An error occurred:', error);
        });
      // this.$refs.filterProgressButtons.filter()
    },
    // TEMPLATES PROJECT, TEMPLATES BUSINESS UNIT
    getTemplatesProject(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/projectTemplates/list?companyId=${router.history.current.query.companyId}`)
            .then(response => {
              loader.hide();
                console.log('---/projectTemplates/list', response.data.list);
                context.commit('getTemplatesProject', response.data.list);
            })
            .catch(error => {
              loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getTemplatesBusinessUnit(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessUnitTemplates/list?companyId=${router.history.current.query.companyId}`)
            .then(response => {
              loader.hide();
                console.log('---/businessUnitTemplates/list', response.data.list);
                context.commit('getTemplatesBusinessUnit', response.data.list);
            })
            .catch(error => {
              loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getTemplatesEngagement(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/engagementTemplates/list?companyId=${router.history.current.query.companyId}`)
        .then(response => {
          loader.hide();
          console.log('---/engagementTemplates/list', response.data.list);
          context.commit('getTemplatesEngagement', response.data.list);
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    // MESSAGES
    getMessagesDirectories(context, index) {
      console.log('---indexxxx', index);
        var obj = index

        if (obj.type == 'task') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectTaskMessages/directories?companyId=${router.history.current.query.companyId}&projectId=${obj.projectId}&projectTaskId=${obj.projectTaskId}&operation=create`)
                .then(response => {
                  loader.hide();
                    console.log('---/projectTaskMessages/directories', response.data);
                    context.commit('getMessagesDirectories', response.data);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'project') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectMessages/directories?companyId=${router.history.current.query.companyId}&projectId=${obj.projectId}&operation=create`)
                .then(response => {
                  loader.hide();
                    console.log('---/projectMessages/directories', response.data);
                    context.commit('getMessagesDirectories', response.data);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'taskBusinessUnit') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/businessUnitTaskMessages/directories?companyId=${router.history.current.query.companyId}&businessUnitId=${obj.businessUnitId}&businessUnitTaskId=${obj.businessUnitTaskId}&operation=create`)
                .then(response => {
                  loader.hide();
                    console.log('---/businessUnitTaskMessages/directories', response.data);
                    context.commit('getMessagesDirectories', response.data);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'businessUnit') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/businessUnitMessages/directories?companyId=${router.history.current.query.companyId}&businessUnitId=${obj.businessUnitId}&operation=create`)
                .then(response => {
                  loader.hide();
                    console.log('---/businessUnitMessages/directories', response.data);
                    context.commit('getMessagesDirectories', response.data);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'engagement') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementMessages/directories?companyId=${router.history.current.query.companyId}&engagementId=${obj.engagementId}&operation=create`)
            .then(response => {
              loader.hide();
              console.log('---/engagementMessages/directories', response.data);
              context.commit('getMessagesDirectories', response.data);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        }else if (obj.type == 'taskEngagement') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementTaskMessages/directories?companyId=${router.history.current.query.companyId}&engagementId=${obj.engagementId}&engagementTaskId=${obj.engagementTaskId}&operation=create`)
            .then(response => {
              loader.hide();
              console.log('---/businessUnitTaskMessages/directories', response.data);
              context.commit('getMessagesDirectories', response.data);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        }
    },
    getMessagesList(context, index) {
        var obj = index

        if (index.type == 'task') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectTaskMessages/list?companyId=${router.history.current.query.companyId}&projectId=${obj.projectId}&projectTaskId=${obj.projectTaskId}&projectTaskMessageType=${obj.projectTaskMessageType}`)
                .then(response => {
                  loader.hide();
                    console.log('---/projectTaskMessages/list', response.data.list);
                    response.data.list = response.data.list.reverse()
                    context.commit('getMessagesList', response.data.list);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'project') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/projectMessages/list?companyId=${router.history.current.query.companyId}&projectId=${obj.projectId}&projectMessageType=${obj.projectMessageType}`)
                .then(response => {
                  loader.hide();
                    console.log('---/projectMessages/list', response.data.list);
                    response.data.list = response.data.list.reverse()
                    context.commit('getMessagesList', response.data.list);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'taskBusinessUnit') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/businessUnitTaskMessages/list?companyId=${router.history.current.query.companyId}&businessUnitId=${obj.businessUnitId}&businessUnitTaskId=${obj.businessUnitTaskId}&businessUnitTaskMessageType=${obj.projectTaskMessageType}`)
                .then(response => {
                  loader.hide();
                    console.log('---/businessUnitTaskMessages/list', response.data.list);
                    response.data.list = response.data.list.reverse()
                    context.commit('getMessagesList', response.data.list);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        } else if (obj.type == 'businessUnit') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/businessUnitMessages/list?companyId=${router.history.current.query.companyId}&businessUnitId=${obj.businessUnitId}&businessUnitMessageType=${obj.projectMessageType}`)
                .then(response => {
                  loader.hide();
                    console.log('---/businessUnitMessages/list', response.data.list);
                    response.data.list = response.data.list.reverse()
                    context.commit('getMessagesList', response.data.list);
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
        }else if (obj.type == 'engagement') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementMessages/list?companyId=${router.history.current.query.companyId}&engagementId=${obj.engagementId}&engagementMessageType=${obj.projectMessageType}`)
            .then(response => {
              loader.hide();
              console.log('---/engagementMessages/list', response.data.list);
              response.data.list = response.data.list.reverse()
              context.commit('getMessagesList', response.data.list);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        }else if (obj.type == 'taskEngagement') {
          const loader = app.loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementTaskMessages/list?companyId=${router.history.current.query.companyId}&engagementId=${obj.engagementId}&engagementTaskId=${obj.engagementTaskId}&engagementTaskMessageType=${obj.projectTaskMessageType}`)
            .then(response => {
              loader.hide();
              console.log('---/engagementTaskMessages/list', response.data.list);
              response.data.list = response.data.list.reverse()
              context.commit('getMessagesList', response.data.list);
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        }
    },
    getNewsMenu(context, index) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/news/topList?langCode=${index ? index : 'en'}`)
          .then(response => {
            console.log('---/news/list', response.data.topList);
            context.commit('getNewsMenu', response.data.topList);
          })
          .catch(error => {
          });
    },
    getProjectHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectHistory/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}`)
        .then(response => {
          loader.hide();
          console.log('project history list', response.data.list)
          context.commit('getProjectHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getProjectTaskHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectTaskHistory/list?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${router.history.current.query.taskId}`)
        .then(response => {
          loader.hide();
          console.log('project task history list', response.data.list)
          context.commit('getProjectTaskHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getBusinessUnitHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessUnitHistory/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}`)
        .then(response => {
          loader.hide();
          console.log('project history list', response.data.list)
          context.commit('getBusinessUnitHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getEngagementHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/engagementHistory/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}`)
        .then(response => {
          loader.hide();
          console.log('engagement history list', response.data.list)
          context.commit('getEngagementHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getBusinessUnitTaskHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessUnitTaskHistory/list?companyId=${router.history.current.query.companyId}&businessUnitId=${router.history.current.query.businessUnitId}&businessUnitTaskId=${router.history.current.query.taskId}`)
        .then(response => {
          loader.hide();
          console.log('project task history list', response.data.list)
          context.commit('getBusinessUnitTaskHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getEngagementTaskHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/engagementTaskHistory/list?companyId=${router.history.current.query.companyId}&engagementId=${router.history.current.query.engagementId}&engagementTaskId=${router.history.current.query.taskId}`)
        .then(response => {
          loader.hide();
          console.log('engagement task history list', response.data.list)
          context.commit('getEngagementTaskHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getUserHistory(context, index){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/users/history?companyId=${router.history.current.query.companyId}&userId=${index.userId}&page=${index.page}`)
        .then(response => {
          loader.hide();
          context.commit('getUserHistory', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getCalendarList(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/calendar/list?companyId=${router.history.current.query.companyId}`)
            .then(response => {
              loader.hide();
            console.log('---/calendar/list', response.data.list)

            let list = []
            for (let i = 0; i < response.data.list.length; i++ ){
                let res = {
                    title: '',
                    startDate: '',
                    endDate: '',

                }

                let start = response.data.list[i].startDate
                let end = response.data.list[i].endDate

                if (start.toString().length < 8) {
                    start = '0' + start.toString()
                } else {
                    start = start.toString()
                }
                if (end.toString().length < 8) {
                    end = '0' + end.toString()
                } else {
                    end = end.toString()
                }

                start = moment(start, 'DD-MM-YYYY').format('YYYY-MM-DD');
                end = moment(end, 'DD-MM-YYYY').format('YYYY-MM-DD');

                res.title = response.data.list[i].title
                res.startDate = start
                res.endDate = end
                res.classes = "purple"

                list.push(res)
            }
            console.log('---CCCCCCCCCCCCCCCCCCCCCCCC', list);


            context.commit('getCalendarList', list)
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
    },
    // TIMER LIST
    getTimerList(context, index) {
      // const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskTimers/list?companyId=${router.history.current.query.companyId}&projectId=${index.projectId}&projectTaskId=${index.projectTaskId}`)
            .then(response => {
              // loader.hide();
                console.log('---/projectTaskTimers/list', response.data.list)

                let list = response.data.list;

                for (let i = 0; i < list.length; i++ ){
                    list[i].time = response.data.timestamp
                }

                context.commit('getTimerList', list)
            })
            .catch(error => {
              // loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getTimerListDep(context, index) {
      // const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskTimers/list?companyId=${router.history.current.query.companyId}&businessUnitId=${index.businessUnitId}&businessUnitTaskId=${index.businessUnitTaskId}`)
            .then(response => {
              // loader.hide();
                console.log('---/businessUnitTaskTimers/list', response.data.list)

                let list = response.data.list;

                for (let i = 0; i < list.length; i++ ){
                    list[i].time = response.data.timestamp
                }

                context.commit('getTimerListDep', list)
            })
            .catch(error => {
              // loader.hide();
                console.log('An error occurred:', error);
            });
    },
    getTimerListCas(context, index) {
      // const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/engagementTaskTimers/list?companyId=${router.history.current.query.companyId}&engagementId=${index.engagementId}&engagementTaskId=${index.engagementTaskId}`)
        .then(response => {
          // loader.hide();
          console.log('---/engagementTaskTimers/list', response.data.list)

          let list = response.data.list;

          for (let i = 0; i < list.length; i++ ){
            list[i].time = response.data.timestamp
          }

          context.commit('getTimerListCas', list)
        })
        .catch(error => {
          // loader.hide();
          console.log('An error occurred:', error);
        });
    },
    // HRIS
    getHrisList(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/companyUserHRISData/item?companyId=${router.history.current.query.companyId}&companyUserId=${router.history.current.query.companyUserId}`)
                .then(response => {
                  loader.hide();
                    console.log('---/companyUserHRISData/item', response.data.data);
                    context.commit('getHrisList', response.data.data)
                })
                .catch(error => {
                  loader.hide();
                    console.log('An error occurred:', error);
                });
    },
    // Rate
    getCostType(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectTasks/getRateData?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${router.history.current.query.taskId}`)
              .then(response => {
                console.log('---/projectTasks/getRateData', response.data);
                context.commit('getCostType', response.data);
                if (response.data.costType !== null) {
                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/projectTasks/rateReport?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${router.history.current.query.taskId}`)
                          .then(response => {
                            loader.hide();
                            console.log('---/projectTasks/rateReport', response.data.rateReport);
                            // this.tooltipUser = response.data.fieldInfo.user
                            context.commit('getRateReport', response.data.rateReport)
                          })
                          .catch(error => {
                            loader.hide();
                            console.log('An error occurred:', error);
                          });
                }else {
                  loader.hide();
                }
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
    },
    // getRateReport({state}, context, index) {
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //   axios.post(`/api/v1/projectTasks/rateReport?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectTaskId=${router.history.current.query.taskId}`)
    //           .then(response => {
    //             console.log('---/projectTasks/rateReport', response.data.rateReport)
    //             // this.tooltipUser = response.data.fieldInfo.user
    //             context.commit('getRateReport', response.data.rateReport)
    //           })
    //           .catch(error => {
    //             console.log('An error occurred:', error);
    //           });
    // },

    // Invoices
    getInvoicesList(context, index) {
      const loader = app.loading.show();
      // alert(index);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectBillSheet/list?companyId=${router.history.current.query.companyId}&projectId=${index}`)
              .then(response => {
                loader.hide();
                console.log('---/projectBillSheet/list', response.data.list)
                // this.tooltipUser = response.data.fieldInfo.user
                context.commit('getInvoicesList', response.data.list)
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
    },
    // Directories create invoices
    getDirectoriesCreateInvoices(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/projectBillSheet/directories?companyId=${router.history.current.query.companyId}&projectId=${index}&operation=create`)
              .then(response => {
                loader.hide();
                console.log('---/projectBillSheet/directories', response.data)
                // this.tooltipUser = response.data.fieldInfo.user
                context.commit('getDirectoriesCreateInvoices', response.data)
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
    },
    // Company Layout
    getCompanyLayout(context, companyId) {
      const loader = app.loading.show();
      return new Promise((resolve, reject) => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/companyLayout/getData?companyId=${companyId || router.history.current.query.companyId}`)
              .then(response => {
                loader.hide();
                // console.log('SOOOOOOCETd',socket)
                console.log('---/companyLayout/getData', response.data)
                // this.tooltipUser = response.data.fieldInfo.user
                context.commit('getCompanyLayout', response.data)
                context.commit('getMenuStatistics', response.data.stats);
                context.commit('setActiveSubscription', response.data.activeSubscription);
                context.commit('setSubscription', response.data.subscription);
                localStorage.setItem('storageSize', response.data.storageSize);
                localStorage.setItem('fullSize', response.data.fullSize);
                resolve(response.data)
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
                reject(error)
              });
           })
    },
    getPurchaseList(context, data) {
      const loader = app.loading.show();
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/purchaseRequest/list?companyId=${router.history.current.query.companyId}&${data.stateId}=${data.id}`)
          .then(response => {
            loader.hide();
            console.log('---/purchaseRequest/list', response.data.list)
            context.commit('getPurchaseList', response.data.list)
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    getPurchaseOrderList(context, data) {
      const loader = app.loading.show();
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/purchaseOrder/list?companyId=${router.history.current.query.companyId}&${data.stateId}=${data.id}`)
          .then(response => {
            loader.hide();
            console.log('---/purchaseOrder/list', response.data.list)
            context.commit('getPurchaseOrderList', response.data.list)
            context.commit('setInventoryManager', response.data.isInventoryManager === 1)
            resolve(response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
            reject(error)
          });
      })
    },
    // getCompanyLayoutPromise(context, index) {
    //   return new Promise((resolve, reject) => {
    //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //     axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //     axios.post(`/api/v1/companyLayout/getData?companyId=${index}`)
    //       .then(response => {
    //         console.log('---/companyLayout/getData', response.data)
    //         // this.tooltipUser = response.data.fieldInfo.user
    //         context.commit('getCompanyLayout', response.data)
    //         resolve(response.data)
    //       })
    //       .catch(error => {
    //         console.log('An error occurred:', error);
    //         reject(error)
    //       });
    //   })
    // }
    // Invoice Item
    getInvoiceItem(context, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/projectBillSheet/item?companyId=${router.history.current.query.companyId}&projectId=${router.history.current.query.projectId}&projectBillSheetId=${router.history.current.query.projectBillSheetId}`)
          .then(response => {
            loader.hide();
              console.log('---/projectBillSheet/item', response.data.item);

              context.commit('getInvoiceItem', response.data.item)
              // this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
              // this.notification("Success", "Delete Invoice", "success");
          })
          .catch(error => {
            loader.hide();
              console.log('An error occurred:', error);
          });
    },
    getBusinessUnitProjectsList(context, businessUnitId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${businessUnitId}`)
          .then(response => {
            loader.hide();
            console.log('---/projects/list', response.data.list);
            context.commit('getBusinessUnitProjectsList', response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
    getBusinessUnitEngagementList(context, businessUnitId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${businessUnitId}`)
          .then(response => {
            loader.hide();
            console.log('---/engagements/list', response.data.list);
            context.commit('getBusinessUnitEngagementList', response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    toggleActiveCompanyName({ commit }, companyName) {
      commit('TOGGLE_ACTIVE_COMPANY_NAME', companyName)
    },
    getProjectPermissionsList(context, projectId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/projects/usersPermissionslist?companyId=${router.history.current.query.companyId}&projectId=${projectId}`)
        .then(response => {
          loader.hide();
          context.commit('getProjectPermissionsList', response.data.list)
        })
        .catch(error => {
          loader.hide();
          console.log('An error occurred:', error);
        });
    },
    getEngagementPermissionsList(context, engagementId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/engagements/usersPermissionslist?companyId=${router.history.current.query.companyId}&engagementId=${engagementId}`)
          .then(response => {
            loader.hide();
            context.commit('getEngagementPermissionsList', response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
    getBusinessUnitPermissionsList(context, businessUnitId){
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/businessUnits/usersPermissionslist?companyId=${router.history.current.query.companyId}&businessUnitId=${businessUnitId}`)
          .then(response => {
            loader.hide();
            context.commit('getBusinessUnitPermissionsList', response.data.list)
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
    approveUploadedImages(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/files/approveNewTmpFile`, payload)
          .then(response => {
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    deleteRemovedImages(context, payload) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/files/deleteNewTmpFile`, {
        fileUrlArr: payload
      })
          .then(response => {
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    hideFileNotification(context, payload){
      context.commit('hideFileNotification', payload);
    }
  },
  modules: {
    estimate,
    quotation,
    salesOrder,
    invoice,
    toDo,
    notifications,
    about,
  }
})
